<template>
  <div>
    <DaysOfWeek
      v-if="timePolicyType !== 'workingDays'"
      :timePolicyType="timePolicyType"
      :days="days"
      :reset="resetDaysOfWeek"
      @setDaysOfWeek="setDaysOfWeek"
    />

    <Debug>{{
    {
      condition: !isValidArray(intervals) && (!validTimeRange || duplicatedTimeRange),
      intervals: isValidArray(intervals),
      validTimeRange: validTimeRange,
      duplicatedTimeRange: duplicatedTimeRange
    }
    }}</Debug>

    <div
      class="selects"
      :class="{ 'selects--error': !isValidArray(intervals) && (!validTimeRange || duplicatedTimeRange) }"
    >
      <!-- :class="{ 'selects--error': !isValidArray(intervals) && (!validTimeRange || duplicatedTimeRange) }" -->
      <span class="label">{{ $t(`${namespace}.to`) }}</span>
      <select  class="select"  ref="startTime" @change="setStartTime">
        <option selected value="null">{{ $t(`${namespace}.startTime`) }}</option>
        <option
          v-for="(startTime, index) in startTimeList"
          :value="startTime"
          :key="`${startTime}-${index}`"
        >
          {{ startTime }}
        </option>
      </select>

      <span class="label">{{ $t(`${namespace}.from`) }}</span>
      <select class="select" ref="endTime" @change="setEndTime">
        <option selected value="null">{{ $t(`${namespace}.endTime`) }}</option>
        <option
          v-for="(endTime, index) in endTimeList"
          :value="endTime"
          :key="`${endTime}-${index}`"
        >
          {{ endTime }}
        </option>
      </select>

      <button class="btn" type="button" @click="handleAddTimePolicy">
        <v-icon color="accent">add</v-icon> <span>{{ $t(`${namespace}.add`) }}</span>
      </button>
    </div>

    <div class="selects__error error--text">
      <transition name="fade">
        <span v-if="!isValidArray(intervals) && !validTimeRange">
          {{ $t(`${namespace}.invalidTimeRangeError`) }}
        </span>

        <span v-if="!isValidArray(intervals) && duplicatedTimeRange">
          {{ $t(`${namespace}.duplicatedTimeRangeError`) }}
        </span>
      </transition>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import { isArray } from 'utils/functions'
import DaysOfWeek from 'components/usagePolicy/timeRangeComboBox/DaysOfWeek'

export default {
  name: 'Selects',
  props: {
    timePolicyType: {
      type: String,
      required: true
    },
    intervals: {
      type: Array,
      required: true
    },
    submit: {
      type: Boolean
    },
    kind: {
      type: String
    }
  },
  components: {
    DaysOfWeek
  },
  data () {
    return {
      namespace: 'Views.UsagePolicyPage.timeRangeComboBox',
      intervalsOrdened: [],
      intervalsList: [],
      startTimeList: [
        '00:00', '00:30', '01:00', '01:30', '02:00', '02:30', '03:00', '03:30', '04:00', '04:30', '05:00', '05:30', '06:00', '06:30', '07:00', '07:30', '08:00', '08:30', '09:00', '09:30', '10:00', '10:30', '11:00', '11:30', '12:00', '12:30', '13:00', '13:30', '14:00', '14:30', '15:00', '15:30', '16:00', '16:30', '17:00', '17:30', '18:00', '18:30', '19:00', '19:30', '20:00', '20:30', '21:00', '21:30', '22:00', '22:30', '23:00', '23:30'
      ],
      endTimeList: [
        '00:29', '00:59', '01:29', '01:59', '02:29', '02:59', '03:29', '03:59', '04:29', '04:59', '05:29', '05:59', '06:29', '06:59', '07:29', '07:59', '08:29', '08:59', '09:29', '09:59', '10:29', '10:59', '11:29', '11:59', '12:29', '12:59', '13:29', '13:59', '14:29', '14:59', '15:29', '15:59', '16:29', '16:59', '17:29', '17:59', '18:29', '18:59', '19:29', '19:59', '20:29', '20:59', '21:29', '21:59', '22:29', '22:59', '23:29', '23:59'
      ],
      days: [],
      startTime: null,
      endTime: null,
      labels: [],
      resetDaysOfWeek: false,

      // validators
      validTimeRange: true,
      duplicatedTimeRange: false
    }
  },
  methods: {
    ...mapActions({
      showAlert: 'snackbar/show'
    }),

    isValidArray (val) {
      return isArray(val)
    },

    setWorkingDays () {
      if (this.timePolicyType === 'workingDays') {
        this.days = [1, 2, 3, 4, 5]
        return
      }

      this.days = []
    },

    setDaysOfWeek (val) {
      this.days = val
    },

    renderLabels () {
      this.$emit('renderLabels', [
        ...this.intervals,
        ...this.intervalsList
      ])
    },

    resetSelectFields () {
      this.startTime = null
      this.endTime = null
      this.$refs['startTime'].value = null
      this.$refs['endTime'].value = null
      if (this.timePolicyType !== 'workingDays') this.days = []
      this.resetDaysOfWeek = !this.resetDaysOfWeek
    },

    resetAllFields () {
      this.resetSelectFields()
      this.labels = []
      this.intervalsList = []

      // this.policies = []
      this.validTimeRange = true
      this.duplicatedTimeRange = false
    },

    setStartTime (event) {
      const value = event.target.value
      this.startTime = value
    },

    setEndTime (event) {
      const value = event.target.value
      this.endTime = value
    },

    setIntervalList () {
      this.intervalsList = this.days.map(day => ({
        dayOfWeek: day,
        startTime: this.startTime,
        endTime: this.endTime
      }))
    },

    renderNewDateObject (time, currentYear = null) {
      const year = currentYear || new Date().getFullYear()
      return new Date(`${year}-01-01T${time}:00`).getTime()
    },

    isValidTimeRange () {
      if (this.startTime && this.endTime) {
        const startTime = this.renderNewDateObject(this.startTime)
        const endTime = this.renderNewDateObject(this.endTime)
        const isValid = startTime < endTime

        if (!isValid) {
          this.validTimeRange = false
          return false
        }
      }

      this.validTimeRange = true
      return true
    },

    hasDuplicatedTimeRange () {
      const startTime = this.renderNewDateObject(this.startTime)
      const endTime = this.renderNewDateObject(this.endTime)
      let hasDuplicatedTimeRange = false

      if (this.timePolicyType === 'workingDays') {
        hasDuplicatedTimeRange = this.intervals.find(item => {
          const itemStartTime = this.renderNewDateObject(item.startTime)
          const itemEndTime = this.renderNewDateObject(item.endTime)

          return item.startTime === this.startTime ||
            item.endTime === this.endTime ||
            (startTime >= itemStartTime && startTime <= itemEndTime) ||
            (endTime >= itemStartTime && endTime <= itemEndTime)
        })
      }

      if (this.timePolicyType === 'customDays') {
        const checkDay = (item, day) => {
          return item.dayOfWeek === day && (item.startTime === this.startTime || item.endTime === this.endTime)
        }

        hasDuplicatedTimeRange = this.intervals.find(item => {
          if (this.days.filter(item => item === 0).length) return checkDay(item, 0)
          if (this.days.filter(item => item === 1).length) return checkDay(item, 1)
          if (this.days.filter(item => item === 2).length) return checkDay(item, 2)
          if (this.days.filter(item => item === 3).length) return checkDay(item, 3)
          if (this.days.filter(item => item === 4).length) return checkDay(item, 4)
          if (this.days.filter(item => item === 5).length) return checkDay(item, 5)
          if (this.days.filter(item => item === 6).length) return checkDay(item, 6)
        })
      }

      this.duplicatedTimeRange = Boolean(hasDuplicatedTimeRange)
      return Boolean(hasDuplicatedTimeRange)
    },

    timeRangeValidator () {
      if (
        this.kind !== 'editar' &&
        this.timePolicyType !== 'workingDays' &&
        !this.isValidArray(this.days) &&
        !this.isValidArray(this.intervals)
      ) {
        this.showAlert({
          type: 'info',
          message: this.$t(`${this.namespace}.intervalError`)
        })

        return false
      }

      if (!this.isValidTimeRange()) {
        this.showAlert({
          type: 'info',
          message: this.$t(`${this.namespace}.invalidTimeRangeError`)
        })

        return false
      }

      if (this.hasDuplicatedTimeRange()) {
        this.showAlert({
          type: 'info',
          message: this.$t(`${this.namespace}.duplicatedTimeRangeError`)
        })

        return false
      }

      return true
    },

    handleAddTimePolicy () {
      const isValidTimeRange = this.timeRangeValidator()

      if (!this.startTime || !this.endTime) {
        this.showAlert({
          type: 'info',
          message: this.$t(`${this.namespace}.intervalError`)
        })

        return
      }

      if (!isValidTimeRange) return

      this.setIntervalList()
      this.renderLabels()
      this.resetSelectFields()
    }
  },
  watch: {
    timePolicyType (val) {
      this.resetAllFields()
      this.setWorkingDays()
    },

    startTime (val) {
      this.duplicatedTimeRange = false
      if (val && this.endTime) this.isValidTimeRange()
    },

    endTime (val) {
      this.duplicatedTimeRange = false
      if (val && this.startTime) this.isValidTimeRange()
    },

    submit () {
      this.timeRangeValidator()
    }
  },
  mounted () {
    this.setWorkingDays()
    this.renderLabels()
  }
}
</script>

<style lang="scss" scoped>
.selects {
  display: flex;
  align-items: center;
  justify-content: center;

  &.selects--error {

    color: #e20d0d !important;

    .select {
      border-color: #e20d0d !important;
    }
  }
}

.select {
  appearance: auto;
  background-color: #ffffff;
  border: 1px solid $gray-4;
  border-radius: 2px;
  height: 24px;
  margin: 0 8px;
  min-width: 136px;
  padding: 0 8px;
  transition: border .26s;
}

.btn {
  align-items: center;
  color: $accent;
  display: flex;
}

.selects__error {
  font-size: 10px;
  min-height: 23px;
  padding: 4px 0;
  text-align: center;
}
</style>
